import * as React from 'react';

import { createIcon } from '../Icon';
export const SquareIcon = createIcon(
  <rect x={3} y={3} width={18} height={18} rx={2} ry={2} />,
  'SquareIcon'
);
